import React, {Component} from 'react';
import DefaultErrorPage from '../pages/error/defaultErrorPage';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    // Ask @Jan @Krzysztof if we can send the error stack somewhere to API
    componentDidCatch(error, info) {
        this.setState({hasError: true});
        console.group('ErrorBoundary');
        console.error(error);
        console.info(info);
        console.groupEnd();
    }

    render() {
        if (this.state.hasError) {
            return this.props.errorPage || <DefaultErrorPage/>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
    errorPage: PropTypes.node,
};
